import { CreateSinglePaymentResponse } from "@/models/payment/create-single/createSinglePaymentResponse";
import { getCompositeKey } from "@/services/format/key";
import envSettings from "@/services/system/envSettings";
import { createEntityAdapter } from "@reduxjs/toolkit";
import { delay, http, HttpResponse } from "msw";
import { SetupServer } from "msw/node";
import { getActiveLoanPaymentSet } from "../sets/activeLoanPayment";
import { infrastructureHandlers } from "./infrastructureHandlers";

const activeLoanPaymentAdapter = createEntityAdapter({
  selectId: (item: CreateSinglePaymentResponse) =>
    getCompositeKey({
      a: "hostedPaymentPageUrl",
      b: item.hostedPaymentPageUrl,
    }).toString(),
});
let activeLoanPaymentState = activeLoanPaymentAdapter.getInitialState();
activeLoanPaymentState = activeLoanPaymentAdapter.setOne(activeLoanPaymentState, getActiveLoanPaymentSet);

const createSingleUrl = `${envSettings.PAYMENT_API_URL}/${envSettings.CREATE_SINGLE_PREF}`;
const registerPaymentUrl = `${envSettings.PAYMENT_API_URL}/${envSettings.REGISTER_PAYMENT_PREF}`;

export const createSinglePaymentHandler = [
  http.post(createSingleUrl, async () => {
    await delay(150);
    return HttpResponse.json(Object.values(activeLoanPaymentState.entities)[0], { status: 200 });
  }),
];

export const registerPaymentHandler = [
  http.post(registerPaymentUrl, async () => {
    await delay(150);
    return HttpResponse.json({ status: 200 });
  }),
];

export const errorStatusCreateSinglePaymentHandler = http.post(createSingleUrl, () => {
  return HttpResponse.json({ message: "Internal server error" }, { status: 500 });
});

export const faultyCreateSinglePaymentHandler = http.post(createSingleUrl, () => {
  return HttpResponse.json({ weirdDataType: "something went wrong" }, { status: 200 });
});

export const setupCreateSinglePaymentHandler = (server: SetupServer) => {
  server.use(...createSinglePaymentHandler, ...infrastructureHandlers);
};

export const setupErrorStatusCreateSinglePaymentHandler = (server: SetupServer) => {
  server.use(errorStatusCreateSinglePaymentHandler);
};

export const setupFaultyCreateSinglePaymentHandler = (server: SetupServer) => {
  server.use(faultyCreateSinglePaymentHandler);
};
